import { render, staticRenderFns } from "./SestLuvReportsWeeks.vue?vue&type=template&id=3885b79b&scoped=true"
import script from "./SestLuvReportsWeeks.vue?vue&type=script&lang=js"
export * from "./SestLuvReportsWeeks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3885b79b",
  null
  
)

export default component.exports